import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class TechnicalServiceGuard implements CanActivate {

  constructor() {}

  canActivate() {
      if (JSON.parse(localStorage.getItem('user')) && (JSON.parse(localStorage.getItem('user')).role == 1 || JSON.parse(localStorage.getItem('user')).role == 2)){
          return true;
      }else{
          return false;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/technicalService.guard.ts